import { Texto, addCommasToNumber } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'

type BillingMethod = 'Gross' | 'Net'
type BillingMethodCellRendererProps = {
  value: number
  method: BillingMethod
  field: BillingMethod
}

export function BillingMethodCellRenderer({ value, method, field }: BillingMethodCellRendererProps) {
  if (!field && !method) return <span>{addCommasToNumber(value)}</span>
  const isBillable = field === method
  return (
    <Tooltip title={isBillable ? 'Billable Volume' : ''}>
      <span>
        <Texto
          weight={isBillable ? 'bold' : 'regular'}
          align='right'
          appearance={isBillable ? 'primary' : 'secondary'}
        >{`${isBillable ? '*' : ''}${addCommasToNumber(value)}`}</Texto>
      </span>
    </Tooltip>
  )
}
